






































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { InbProduct } from '@/models/InbProduct';
import http from '@/services/Http';

@Component
export default class ProductQuickReferenceGuide extends Vue {
    protected searchText: string = '';
    inbProducts: InbProduct[] = [] as InbProduct[];
    selectedInbProduct: InbProduct | null = null;
    loading: boolean = false;

    public setSelectedInbProduct(inb: InbProduct) {
        this.selectedInbProduct = inb;
    }

    private search() {
        this.loading = true;
        const request = http.get(`/api/productquickreferenceguide?searchtext=${this.searchText}`);
        request.then((response: any) => {
            this.loading = false;
            const data = response.json();
            data.then((reponse: InbProduct[]) => {
                this.inbProducts = reponse as InbProduct[];
            });
        });
    }
}
